import toast from 'svelte-french-toast';

class Toast {
	static primary_color: string = '#2b76ff';
	static error_color: string = '#fe3522';
	static warning_color: string = '#ffb700';

	static normal(msg: string) {
		toast.success(msg, {
			style: `border: 1px solid ${this.primary_color}; padding: 10px 16px; color: ${this.primary_color};`,
			iconTheme: {
				// primary: '#713200',
				primary: this.primary_color,
				secondary: '#FFFAEE',
			},
			// duration: 100000,
		});
	}
	static info(msg: string) {
		toast.success(msg, {
			style: `border: 1px solid ${this.primary_color}; padding: 10px 16px; color: ${this.primary_color};`,
			iconTheme: {
				// primary: '#713200',
				primary: this.primary_color,
				secondary: '#FFFAEE',
			},
			// duration: 100000,
		});
	}
	static success(msg: string) {
		toast.success(msg);
	}
	static warn(msg: string) {
		toast(msg, {
			icon: '⚠️',
			style: `border: 1px solid ${this.warning_color}; padding: 10px 16px; color: ${this.warning_color};`,
		});
	}
	static error(msg: string) {
		toast.error(msg, {
			style: `border: 1px solid ${this.error_color}; padding: 10px 16px; color: ${this.error_color};`,
			// iconTheme: {
			// 	// primary: '#713200',
			// 	primary: primary_color,
			// 	secondary: '#FFFAEE',
			// },
		});
	}
	static async loadWithProcess(promise: Promise<unknown>, option = null) {
		option = {
			...{
				loading: 'Saving...',
				success: '保存しました！',
				error: '保存に失敗しました。',
			},
			...option,
		};
		return await toast.promise(promise, option);
	}
}

export { Toast };
